import { ApiErrorDTO } from "@bvhi/backend-api";
import { ReactNode, useState } from "react";
import { ErrorDialog } from "../dialogs/error-dialog";
import { ApiErrorContext } from "./api-error-context";

interface Props {
  children: ReactNode;
}

export function ApiErrorContextProvider({ children }: Props) {
  const [apiError, setApiError] = useState<ApiErrorDTO>();

  return (
    <ApiErrorContext.Provider value={{ setErrors: setApiError }}>
      {children}
      <ErrorDialog
        error={apiError}
        open={apiError !== undefined}
        onClose={() => {
          setApiError(undefined);
        }}
      />
    </ApiErrorContext.Provider>
  );
}
